import React from 'react';
import { PageHeader } from 'antd';

import { PropertiesList } from '@containers/properties';

function PropertiesPage() {
  return (
    <div className="properties main-page">
      <PageHeader
        title="Properties"
        style={{
          border: '1px solid rgb(235, 237, 240)'
        }}
      />
      <PropertiesList />
    </div>
  );
}

export default PropertiesPage;
